export default function(queryString, key) {
	let obj = null;
	if (queryString && queryString.includes('?')) {
		queryString = queryString.split('?')[1];
		const params = new URLSearchParams(queryString);
		obj = params && params.get(key);
	}
	return obj;
}
